import { JSX, useContext } from "react";
import { NetworkIntegrityProviderTypeFilter } from '.';
import { CountyProjectContext } from "@app/projects";

const NetworkIntegrityFilterContainer = (): JSX.Element => {
  const context = useContext(CountyProjectContext);
  const projectIncludesAdequacy = (context.runConfiguration.adequacyTemplateCollectionId) ? true : false;

  return (<div>
    {(projectIncludesAdequacy) && <NetworkIntegrityProviderTypeFilter /> }
  </div>);
}

export default NetworkIntegrityFilterContainer;